import React, { useEffect } from 'react';
import FeaturedWork from '../components/FeaturedWork';
import Categories from '../components/Categories';

const WorkPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white pt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mb-16">
        <h1 className="text-6xl md:text-7xl font-bold mb-6">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-400 to-amber-600">
            Portfolio
          </span>
        </h1>
        <p className="text-xl text-gray-400 max-w-3xl">
          A showcase of cinematic storytelling across commercials, short films, and digital campaigns.
        </p>
      </div>
      <FeaturedWork />
      <Categories />
    </div>
  );
};

export default WorkPage;